import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {
	UsersDetail
} from '@/common/api.js'

export default new Vuex.Store({
	state: {
		// 用户校验
		token: localStorage.getItem("token") || '',
		// 用户信息
		uInfo: localStorage.getItem("uInfo") ? JSON.parse(localStorage.getItem("uInfo")) : {},
		// 网站信息
		dInfo: localStorage.getItem("dInfo") ? JSON.parse(localStorage.getItem("dInfo")) : {},
		// 搜索页输入框值
		searchKeyword: localStorage.getItem("searchKeyword") || '',
		// 注册信息
		regInfo: localStorage.getItem("regInfo") ? JSON.parse(localStorage.getItem("regInfo")) : {},
		// 缓存的组件名数组
		cachedViews: ['home', 'information']
	},
	getters: {
		isLogin: state => {
			if (!state.token) {
				return false
			}
			return true;
		},
	},
	mutations: {
		ADD_CACHED_VIEW: (state, view) => {
			if (state.cachedViews.includes(view)) return
			state.cachedViews.push(view)
			console.log('添加缓存页面',view);
		},
		DEL_CACHED_VIEW: (state, view) => {
			const index = state.cachedViews.indexOf(view)
			if (index > -1) {
				state.cachedViews.splice(index, 1)
				console.log('移除缓存页面',view);
			}
		},
		DEL_ALL_CACHED_VIEWS: (state) => {
			state.cachedViews = []
			console.log('清空缓存页面');
		},
		changeToken(state, data = '') {
			try {
				localStorage.setItem("token", data)
			} catch (error) {}
			state.token = data
		},
		changeUInfo(state, data = {}) {
			try {
				localStorage.setItem("uInfo", JSON.stringify(data))
			} catch (error) {}
			state.uInfo = data
		},
		changeDInfo(state, data = {}) {
			try {
				localStorage.setItem("dInfo", JSON.stringify(data))
			} catch (error) {}
			state.dInfo = data
		},
		changeSearchKeyword(state, data = {}) {
			try {
				localStorage.setItem("searchKeyword", data)
			} catch (error) {}
			state.searchKeyword = data
		},
		changeRegInfo(state, data = {}) {
			try {
				localStorage.setItem("regInfo", JSON.stringify(data))
			} catch (error) {}
			state.regInfo = data
		},
	},
	actions: {
		addView({
			commit
		}, view) {
			commit('ADD_CACHED_VIEW', view)
		},
		delView({
			commit
		}, view) {
			return new Promise(resolve => {
				commit('DEL_CACHED_VIEW', view)
				resolve()
			})
		},
		// 更新用户信息
		updateUInfo({
			dispatch,
			commit,
			state
		}, data = '') {
			return new Promise((resolve, reject) => {
				if (state.token) {
					UsersDetail()
						.then(res => {
							commit('changeUInfo', res.data)
							resolve(res)
						})
						.catch(err => {
							reject(err)
						})
				} else {
					reject()
				}
			})
		},
	},
	modules: {}
})